// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TLy0","fullView":"styles_fullView__3TJIv"};